import { render } from "./GarmentPreview.vue?vue&type=template&id=0db16ae8&scoped=true"
import script from "./GarmentPreview.vue?vue&type=script&lang=js"
export * from "./GarmentPreview.vue?vue&type=script&lang=js"

import "./GarmentPreview.vue?vue&type=style&index=0&id=0db16ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db16ae8"]])

export default __exports__